import { render, staticRenderFns } from "./EditEventDescriptionModal.vue?vue&type=template&id=4baab680&"
import script from "./EditEventDescriptionModal.vue?vue&type=script&lang=ts&"
export * from "./EditEventDescriptionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports